const ALLOWED_CATALOG_ADDON_IDS = new Set([
    'com.linvo.cinemeta',
    'pw.ers.netflix-catalog',
]);
const ALLOWED_CATALOG_MANIFESTS = new Map([
    ['v3-cinemeta.strem.io', '/manifest.json'],
    ['7a82163c306e-stremio-netflix-catalog-addon.baby-beamup.club', '/manifest.json'],
]);

const isAllowedCatalogTransportUrl = (transportUrl) => {
    if (typeof transportUrl !== 'string') return false;

    try {
        const url = new URL(transportUrl);
        return url.protocol === 'https:' &&
            ALLOWED_CATALOG_MANIFESTS.get(url.hostname.toLowerCase()) === url.pathname.replace(/\/+$/, '');
    } catch (_) {
        return false;
    }
};

const isAllowedCatalogAddon = (addon) => {
    if (typeof addon?.transportUrl === 'string') {
        return isAllowedCatalogTransportUrl(addon.transportUrl);
    }

    return ALLOWED_CATALOG_ADDON_IDS.has(addon?.manifest?.id);
};

const isAllowedCatalog = (catalog) => isAllowedCatalogAddon(catalog?.addon) ||
    isAllowedCatalogAddon(catalog?.catalog?.addon) ||
    isAllowedCatalogAddon(catalog);

// Keep Core's original row indexes intact for LoadRange while hiding catalogs
// from other addons in the Caroline UI.
const hideUnapprovedCatalogs = (catalogs) => Array.isArray(catalogs) ? catalogs.map((catalog) => (
    isAllowedCatalog(catalog) ? catalog : {
        ...catalog,
        content: { type: 'Err', content: 'EmptyContent' },
    }
)) : [];

const loadAllowedCatalogRange = (catalogs, range, loadRange) => {
    if (!Array.isArray(catalogs)) return;

    let segmentStart = null;
    let segmentEnd = null;
    for (let index = range.start; index <= range.end; index += 1) {
        if (isAllowedCatalog(catalogs[index])) {
            if (segmentStart === null) segmentStart = index;
            segmentEnd = index;
        } else if (segmentStart !== null) {
            loadRange({ start: segmentStart, end: segmentEnd });
            segmentStart = null;
            segmentEnd = null;
        }
    }
    if (segmentStart !== null) loadRange({ start: segmentStart, end: segmentEnd });
};

module.exports = {
    hideUnapprovedCatalogs,
    isAllowedCatalog,
    loadAllowedCatalogRange,
};
